import { ApiResponse, postRequest } from "@/data/apiClient";

export interface OIDCAuthRequest {
  client_id: string | undefined;
  redirect_uri: string | undefined;
  scope: string | undefined;
  state: string | undefined;
  nonce: string | undefined;
}

export const getOIDCCode = async (
  data: OIDCAuthRequest
): Promise<ApiResponse<{ code: string; errorMessage?: string }>> =>
  postRequest("oidc/code", data);
